import React from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import { BOOK_A_CALL_LINK } from "components/account_management/utils";
import SendInviteModal from "components/modals/SendInviteModal";
import Button from "components/ui/button/Button";
import { appRoutes } from "lib/appRoutes";
import { RELEVANCY_SEARCH_NEW_USERS, useVariableValue } from "lib/featureFlags";
import { usePqlActioned } from "lib/hooks/api/users/usePqlActioned";
import { useDialogManager } from "lib/providers/DialogManager";
import { routes } from "lib/routes";
import { EventData, EventNames, useTracking } from "lib/tracking";
import { PqlActionType } from "lib/types/graphQLEnums";
import { WidgetTitle } from "./util";

const eventData = {
  "Context source": "Homepage quick links",
  "Page source": "Homepage",
} as EventData;

function QuickLinks() {
  const isRelevancySearchEnabled = useVariableValue(RELEVANCY_SEARCH_NEW_USERS, false);
  const dialogManager = useDialogManager();
  const { logEvent } = useTracking();

  const { mutate: actionPql } = usePqlActioned(undefined, undefined, false);

  return (
    <Flex column gap={16}>
      <WidgetTitle>Quick links</WidgetTitle>
      <Links>
        <Button
          icon="arrowUpRight"
          as="a"
          href={BOOK_A_CALL_LINK}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            logEvent(EventNames.paywallActioned, { ...eventData, Action: "Book a demo in-app" });
            actionPql({
              actionType: PqlActionType.BookADemoInApp,
              pageUrl: window.location.href,
              contextSource: "Homepage quick links",
            });
          }}
          buttonStyle="inverse"
          justifyContent="left"
        >
          Book a call
        </Button>
        <Button
          icon="usersPlus02"
          onClick={() => dialogManager.openDialog(SendInviteModal, {})}
          buttonStyle="inverse"
          justifyContent="left"
        >
          Add team members
        </Button>
        {!isRelevancySearchEnabled && (
          <Button
            icon="signal01"
            as="a"
            {...appRoutes.feedSettings}
            onClick={() => logEvent(EventNames.relevanceScoreUpdateSettings, eventData)}
            buttonStyle="inverse"
            justifyContent="left"
          >
            Change signal settings
          </Button>
        )}
        <Button
          icon="integration"
          as="a"
          {...appRoutes.integrations}
          buttonStyle="inverse"
          justifyContent="left"
        >
          Setup an integration
        </Button>
        <Button
          icon="helpCircle"
          as="a"
          // eslint-disable-next-line no-restricted-syntax -- external help centre
          href={routes.help}
          target="_blank"
          onClick={() =>
            logEvent(EventNames.clickedHelpCentre, {
              ...eventData,
              "Destination url": routes.help,
            })
          }
          buttonStyle="inverse"
          justifyContent="left"
        >
          Visit our help centre
        </Button>
      </Links>
    </Flex>
  );
}

const Links = styled.div(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(216px, 1fr))",
  gap: "8px",
  marginLeft: "-8px",
  color: theme.colors.sysTextSecondary,
}));

export default QuickLinks;
